const DataMixins = {
    methods: {
        itemImage(img: string) {
            const fileName = img.toLowerCase()
            return require(`@/assets/previews/${fileName}.jpg`)
        },

        itemGameLogo(img: string) {
            const fileName = img.toLowerCase()
            return require(`@/assets/game-logos/${fileName}.png`)
        },

        previewPic(img: string) {
            return `../storage/previews/${img}`
        },

        similarCardsPic(img: string) {
            return `../../storage/previews/${img}`
        },

        carouselPic(img: string) {
            return `../../storage/mod-images/${img}`
        },

        sliceTitle(title: string, len=21) : string {
            let sliced = title.slice(0,len);
            if (sliced.length < title.length) {
                sliced += '...';
            }
            return sliced
        },

        timeAgo(value: number,
                         singular: string,
                         plural: string,
                         pluralFew: string
        ): string {
            if (value === 1) {
                return `1 ${singular} назад`;
            } else if (value >= 2 && value <= 4) {
                return `${value} ${pluralFew} назад`;
            } else {
                return `${value} ${plural} назад`;
            }
        },


        getTimeAgoString(timestamp: string): string {
            const now = new Date();
            const date = new Date(timestamp);
            const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

            interface TimeInterval {
                seconds: number;
                singular: string;
                plural: string;
                pluralFew: string;
            }

            const timeIntervals: TimeInterval[] = [
                { seconds: 31536000, singular: "год", plural: "лет", pluralFew: "года" },
                { seconds: 2592000, singular: "месяц", plural: "месяцев", pluralFew: "месяца" },
                { seconds: 86400, singular: "день", plural: "дней", pluralFew: "дня" },
                { seconds: 3600, singular: "час", plural: "часов", pluralFew: "часа" },
                { seconds: 60, singular: "минута", plural: "минут", pluralFew: "минуты" },
            ];

            for (const interval of timeIntervals) {
                const value = Math.floor(seconds / interval.seconds);
                if (value >= 1) {
                    return this.timeAgo(
                        value, interval.singular,
                        interval.plural, interval.pluralFew
                    );
                }
            }

            return seconds === 1 ? "1 секунда назад" : `${seconds} секунд назад`;
        },

        getStringTimestamp(timestamp: string, toTimeString: boolean = false) : string {
            let curr = new Date(timestamp)

            if(toTimeString) {
                return curr.toLocaleTimeString('ru-RU', {
                    hour: "2-digit", minute: "2-digit" }
                );
            }

            return curr.toLocaleString('ru-RU', {dateStyle: "short", timeStyle: "short"})
        },

        getStringDownloads(downloads: number) : string {
            return downloads.toString() + ' скачиваний'
        },

        getStringViews(views: number) : string {
            views = Math.abs(Math.floor(views));
            const last2 = views % 100;
            if (last2 >= 11 && last2 <= 14) return `${views} просмотров`;
            const last = views % 10;
            if (last === 1) return `${views} просмотр`;
            if (last >= 2 && last <= 4) return `${views} просмотра`;
            return `${views} просмотров`;
        },

        getStringLikes(likes: number) : string {
            likes = Math.abs(Math.floor(likes));
            const last2 = likes % 100;
            if (last2 >= 11 && last2 <= 14) return `${likes} лайков`;
            const last = likes % 10;
            if (last === 1) return `${likes} лайк`;
            if (last >= 2 && last <= 4) return `${likes} лайка`;
            return `${likes} лайков`;
        },

        getPrettyGame(game: string) : string  {
            let gameMap = new Map([
                ["euro-truck-simulator-2", "Euro Truck Simulator 2"],
                ["assetto-corsa", "Assetto Corsa"],
                ["beamng-drive", "BeamNG.Drive"],
                ["american-truck-simulator", "American Truck Simulator"],
                ["city-car-driving", "City Car Driving"]
            ]);

            return gameMap.get(game)!
        },

        getPrettyCategory(category: string): string {
            let categoryMap = new Map([
                ["trucks", "Грузовики и пикапы"],
                ["cars", "Легковые машины"],
                ["buses", "Автобусы"],
                ["skins", "Скины"],
                ["maps", "Карты"],
                ["sportcars", 'Гоночные авто'],
                ["suvs", "Кроссоверы"],
                ["buses", "Автобусы"],
            ]);

            return categoryMap.get(category)!
        },

        getEyeCandyNum(num: number) : string {
            if(num > 999) {
                num = Math.sign(num)*(num/1000)
                return num.toFixed(1) + 'k'
            } else {
                return (Math.sign(num)*num).toString()
            }
        },

        getCorrectEnding(int: number, array: string[]) {
            return (array = array || ['товар', 'товара', 'товаров']) && array[(int % 100 > 4 && int % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(int % 10 < 5) ? int % 10 : 5]];
        },
    }
}

export default DataMixins